import { keyForRowLike } from "./rijHelpers";

export function getLoadedPhysicalRowCount(rowsByKey, row) {
  if (!rowsByKey || typeof rowsByKey.get !== "function") return null;

  const rowKey = keyForRowLike(row);
  if (!rowKey) return null;

  const physicalRow = rowsByKey.get(rowKey);
  if (!physicalRow) return null;

  const count = Number(physicalRow.huidige_bezetting || 0);
  return Number.isFinite(count) ? count : 0;
}

export function removePhysicalRowFromQueue(rows, rowToRemove) {
  const targetKey = keyForRowLike(rowToRemove);
  if (!targetKey) return Array.isArray(rows) ? rows : [];

  return (Array.isArray(rows) ? rows : []).filter(
    (row) => keyForRowLike(row) !== targetKey
  );
}
